import React from "react";
import { Box } from "@chakra-ui/react";
import Success from "../home/component/Success";
import Footer from "../header/Footer";
import Hero from "../about/component/Hero";
import Benefits from "./Components/Benefits";
import CareerOpenings from "./Components/CareerOpenings";
import HowToApply from "./Components/Howtoapply";
import useScrollAnimation from "component/useScrollAnimation";

const Carrer = () => {
  useScrollAnimation();
  return (
    <>
     <Box  fontFamily={'Archivo'}>
      <Hero
        heading="Career"
        subHeading="Join the Doggle Revolution"
        flippedBG
      />
      <Benefits />
      <CareerOpenings />
      <HowToApply/>
      </Box>
      <Box bg="#B18E64">
        <Success />
        <Footer />
      </Box>
    </>
  );
};

export default Carrer;
